import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-921ff430"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-tmc" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "px-4 py-3 mt-6 bg-white border" }
const _hoisted_5 = { class: "flex items-center justify-end mt-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Создание ТМЦ" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_the_input, {
        disabled: _ctx.state.is_loading,
        placeholder: "Код 1С",
        value: _ctx.state.code_1c,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.code_1c) = $event))
      }, null, 8, ["disabled", "value"]),
      _createVNode(_component_the_input, {
        class: "mt-3",
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_validation.name.$error,
        "validation-errors": _ctx.state_validation.name.$errors,
        placeholder: "Название",
        value: _ctx.state.name,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.name) = $event))
      }, null, 8, ["disabled", "is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_input, {
        class: "mt-3",
        disabled: _ctx.state.is_loading,
        "is-invalid": _ctx.state_validation.short_name.$error,
        "validation-errors": _ctx.state_validation.short_name.$errors,
        placeholder: "Короткое название",
        value: _ctx.state.short_name,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.short_name) = $event))
      }, null, 8, ["disabled", "is-invalid", "validation-errors", "value"]),
      _createVNode(_component_the_select, {
        disabled: _ctx.state.is_loading,
        class: "mt-4",
        placeholder: "Единица измерения",
        "is-invalid": _ctx.state_validation.unit_id.$error,
        "validation-errors": _ctx.state_validation.unit_id.$errors,
        loading: _ctx.data_state.units.is_loading,
        failed: _ctx.data_state.units.is_failed,
        "error-text": "При получении списка единиц измерения произошла ошибка",
        options: _ctx.data_state.units.list,
        value: _ctx.state.unit_id,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.unit_id) = $event)),
        "infinite-scroll": "",
        "search-by": "name",
        onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadUnits(_ctx.data_state.units.pagination.current_page))),
        onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreUnits(_ctx.data_state.units.pagination.current_page + 1))),
        onSearch: _ctx.searchUnits,
        onOptionBySearch: _ctx.unshiftFindedUnit
      }, null, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
      _createVNode(_component_checkbox, {
        label: "ТМЦ для вторичного поступления",
        value: _ctx.state.isSecondMaterial,
        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.isSecondMaterial) = $event)),
        class: "mt-3",
        disabled: _ctx.loading
      }, null, 8, ["value", "disabled"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.state.is_loading,
        onClick: _ctx.submitForm
      }, {
        default: _withCtx(() => [
          _hoisted_6,
          _createTextVNode(" Создать ТМЦ ")
        ]),
        _: 1
      }, 8, ["loading", "onClick"])
    ])
  ]))
}